import React from "react";

function Inner_Flight_Tab({ item, icons, hideImages = false, staticData }) {
  return (
    <div className="itinerary_card">
      <div className="day_card">
        {item?.description && <p className="day_desc">{item?.description}</p>}

        {item.checkout && (
          <div className="checkout_box">
            <img src={icons.checkout} className="icon_img" alt="checkout" />
            {item.checkout}
          </div>
        )}

        <div className="section_title">
          <img src={icons?.car} className="icon_img" alt="" />
          {item?.transferType}
        </div>

        <div className="transfer_mode">{item?.transferMode}</div>

        {staticData.type === "flight" && (
          <div className="section_box">
            <div className="section_title">
              <img src={icons.flight} className="icon_img" alt="flight" />
              Flight
            </div>

            <p className="flight_title">
              Flight - Reykjavik Airport to Akureyri Airport
            </p>

            {!hideImages && (
              <div className="flight_card">
                <div className="airline_name">
                  <span className="dot"></span> {staticData?.airline}
                </div>

                <div className="flight_main">
                  <div className="flight_left">
                    <div className="flight_row">
                      <div className="flight_col">
                        <h6>{staticData?.departTime}</h6>
                        <b>{staticData?.from}</b>
                        <p className="city_name">{staticData?.fromCity}</p>
                      </div>

                      <div className="flight_path">
                        <span className="dash_line"></span>

                        <img
                          src="/assets/images/icons/plane.png"
                          className="plane_icon"
                          alt=""
                        />

                        <span className="dash_line"></span>
                      </div>

                      <div className="flight_col">
                        <h6>{staticData?.arriveTime}</h6>
                        <b>{staticData?.to}</b>
                        <p className="city_name">{staticData?.toCity}</p>
                      </div>
                    </div>

                    <div className="duration_text">{staticData?.duration}</div>
                  </div>

                  <div className="baggage_section">
                    <p className="baggage_title">Baggage</p>
                    <p className="small-text">
                      <img
                        src="/assets/images/icons/icon1.png"
                        className="inner_img"
                      />{" "}
                      Cabin: {staticData?.baggageCabin}
                    </p>
                    <p className="small-text">
                      <img
                        src="/assets/images/icons/icon2.png"
                        className="inner_img"
                      />{" "}
                      Checkin: {staticData?.baggageCheckin}
                    </p>
                  </div>

                  <div className="refund_section">
                    <p className="refund-text">{staticData?.refund}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Inner_Flight_Tab;
